// resources/js/app.js
import './bootstrap' // axios, CSRF atd.

import { createApp, h } from 'vue'
import { createInertiaApp, Link } from '@inertiajs/inertia-vue3'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import { InertiaProgress } from '@inertiajs/progress'
import DefaultLayout from '@/Layout/DefaultLayout.vue'

/* ─────────── Inertia progress-bar ─────────── */
InertiaProgress.init({
  delay: 100,
  color: '#16a34a',
  includeCSS: true,
  showSpinner: false,
})

/* ─────────── Inertia SPA bootstrap ─────────── */
createInertiaApp({
  // Resolver s code-splittingem + výchozí layout, pokud stránka žádný neurčí
  resolve: name =>
    resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue'))
      .then(mod => {
        mod.default.layout ??= DefaultLayout
        return mod
      }),

  setup({ el, App, props, plugin }) {
    const app = createApp({ render: () => h(App, props) })
      .use(plugin)

    // Volitelné: <Link> globálně (pak ho nemusíš importovat na stránkách)
    app.component('Link', Link)

    app.mount(el)
  },

  // Volitelné: přizpůsobení titulku
  title: title => (title ? `${title} · Dovoz` : 'Dovoz'),
})
